import PaymentCollection from './finance/PaymentCollection';

/**
 * `/dashboard/finance/cloudgm/merchants/agent-payments` — iter-261 (Feb 2026).
 *
 * Dedicated ledger for AGENT-only invoices (platform === 'agents').
 *
 * IMPORTANT: The user's rule (from message 3 of the batch) is that agent
 * invoices must NOT bleed into the general "cloudgm_merchants" invoice
 * records. The `platform` filter on the invoices_v2 collection enforces
 * that isolation server-side; this component simply scopes the reused
 * PaymentCollection UI to the correct platform key.
 */
export default function MerchantAgentPayments() {
  return <PaymentCollection platformOverride="agents" />;
}
